import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { RsvpResponseStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type RsvpsRespondedReportListProps = {
    points: RsvpResponseStatsPoint[];
};

type SummaryRow = RsvpResponseStatsPoint & { id: number };

export default function RsvpsRespondedReportList({
    points,
}: RsvpsRespondedReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'acceptedCount',
                header: 'Accepted',
                size: 130,
            },
            {
                accessorKey: 'declinedCount',
                header: 'Declined',
                size: 130,
            },
            {
                accessorKey: 'pendingCount',
                header: 'Pending',
                size: 130,
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No RSVP responses found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='RSVPs Responded Summary'
            />
        </Box>
    );
}
